import { render, staticRenderFns } from "./PurchaseStatusBadge.vue?vue&type=template&id=2e9471e4"
import script from "./PurchaseStatusBadge.vue?vue&type=script&lang=js"
export * from "./PurchaseStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports